/* @flow */

import * as React from 'react';

import Rive from '@rive-app/react-canvas';

import {TrialGatheringLayout} from 'shells/trial-gathering/trial-gathering-layout';

import {TinyIntroCheckboxButtons} from '../../fields/tiny-intro-checkbox-buttons';

import {ANIMATION_SRC, NUMBER_OF_STEPS, REASON_OPTIONS} from '../consts';

type Props = {|
    onSkip: () => void,
    onBack: () => void,
    onNext: () => void,
    whatBringsYou: string[],
    setWhatBringsYou: (whatBringsYou: string[]) => void,
    handleStepViewed: () => void,
|};

export function WhatBringsYou(props: Props) {
    React.useEffect(() => {
        props.handleStepViewed();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <TrialGatheringLayout
            prompt='What brings you to Nutshell?'
            instructions='Select all that apply'
            currentStep={2}
            totalSteps={NUMBER_OF_STEPS}
            animation={<Rive src={ANIMATION_SRC.WHAT_BRINGS_YOU} />}
            animationBackgroundColor='green'
            onSkip={props.onSkip}
            onBack={props.onBack}
            onNext={props.onNext}
        >
            <TinyIntroCheckboxButtons
                title=''
                options={REASON_OPTIONS}
                variant='controlled'
                name='checkboxbuttons'
                value={props.whatBringsYou}
                onChange={props.setWhatBringsYou}
            />
        </TrialGatheringLayout>
    );
}
